import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { ActivityService } from '../../activityServices/activity.service';
import { AuthService } from 'projects/patient/src/app/core/auth/services/auth.service';
import { ActivityLogModalComponent } from '../activity-log-modal/activity-log-modal.component';

@Component({
  selector: 'patient-activity-tracking',
  standalone: true,
  imports: [CommonModule, ActivityLogModalComponent, DialogModule],
  templateUrl: './activity-tracking.component.html',
  styleUrl: './activity-tracking.component.css'
})
export class ActivityTrackingComponent implements OnInit {
  private activityService = inject(ActivityService);
  private authService = inject(AuthService);
  private router = inject(Router);

  patientId: string = '';
  showLogModal: boolean = false;
  showNoGoalDialog: boolean = false;
  hasGoal: boolean = true;
  
  // Stats
  dailyGoal: number = 45; // default fallback
  progress: number = 0;   // default fallback
  caloriesBurned: number = 0;
  progressPercentage: number = 0;

  ngOnInit(): void {
    this.getPatientId();
  }

  getPatientId() {
    this.authService.getUserProfile().subscribe((res) => {
      if (res?.PatientId) {
        this.patientId = res.PatientId;
        this.loadTodayOverview();
      }
    });
  }

  loadTodayOverview() {
    if (!this.patientId) return;
    
    this.activityService.getActivityUserAnalyticsOverview(this.patientId).subscribe({
      next: (res) => {
        if (res && res.data) {
          this.hasGoal = true;
          const data = res.data;
          this.dailyGoal = data.daily_goal || 45;
          this.progress = data.progress !== undefined ? data.progress : 0;
          this.caloriesBurned = data.calories_burned || 0;
          
          if (this.dailyGoal > 0) {
            this.progressPercentage = Math.min(100, Math.round((this.progress / this.dailyGoal) * 100));
          } else {
            this.progressPercentage = 0;
          }
        } else {
          this.hasGoal = false;
        }
      },
      error: (err) => {
        console.error('Error fetching today\'s activity overview:', err);
        const isNoGoal = err.status === 404 || 
                         err.error?.status === 404 || 
                         err.error?.message?.toLowerCase().includes('no goal') ||
                         err.message?.toLowerCase().includes('no goal');
        
        if (isNoGoal) {
          this.hasGoal = false;
        } else {
          this.hasGoal = false; // default to false on load failures to prevent errors
        }
      }
    });
  }

  navigateToActivityMain() {
    if (!this.hasGoal) {
      this.showNoGoalDialog = true;
    } else {
      this.router.navigate(['/activity-tracking']);
    }
  }

  openLogModal(event: Event) {
    event.stopPropagation(); // prevent navigating when clicking + Log button
    if (!this.hasGoal) {
      this.showNoGoalDialog = true;
    } else {
      this.showLogModal = true;
    }
  }

  goToPreAssessment() {
    this.showNoGoalDialog = false;
    this.router.navigate(['/create-appointment']);
  }

  onActivityLogged() {
    this.loadTodayOverview();
  }

  get knobX(): number {
    const angle = (this.progressPercentage / 100) * 2 * Math.PI;
    return 18 + 16 * Math.cos(angle);
  }

  get knobY(): number {
    const angle = (this.progressPercentage / 100) * 2 * Math.PI;
    return 18 + 16 * Math.sin(angle);
  }
}
